export const courseInitialState = [
  {
    course_name: "Object Oriented Programming",
    course_code: "SWEG101",
    owner: "Electrical Department",
    program: "Msc",
    credit_hr: 4,
    lecture: 4,
    lab: 2,
    tutorial: 4,
    mentoring: 3,
    advisory: 2,
    total_leh: 30,
    disabled: false,
  },
  {
    course_name: "Object Oriented Programming",
    course_code: "SWEG102",
    owner: "Electrical Department",
    program: "Msc",
    credit_hr: 4,
    lecture: 4,
    lab: 2,
    tutorial: 4,
    mentoring: 3,
    advisory: 2,
    total_leh: 30,
    disabled: false,
  },
  {
    course_name: "Object Oriented Programming",
    course_code: "SWEG104",
    owner: "Electrical Department",
    program: "Msc",
    credit_hr: 4,
    lecture: 4,
    lab: 2,
    tutorial: 4,
    mentoring: 3,
    advisory: 2,
    total_leh: 30,
    disabled: false,
  },
];
